import {call, put, takeLatest, all} from 'redux-saga/effects';
import { FETCH_LOGIN, FETCH_LOGOUT, fetchLoginOk, fetchLogoutOk } from './actions';
import Api from '../../services/api';
// import { setErrors } from "../../actions";
// Config
import routes from '../../config/routes';

function * fetchLoginSaga(action) {
  console.log('fetchLoginSaga')
  const { success, error } = action.callbacks || {}; // Destructure safely
  const { user } = action.payload;

  try {
    const response = yield call(Api.handlePost, routes.session.create, {}, {user: user});

    if (response.status) {
      yield put(fetchLoginOk(response));  // Standard Redux action
      success?.(response);                // Optional callback
    } else {
      // yield put(setErrors('login', response.message));
      error?.("Error en la contraseña o en el email");
    }
  } catch (err) {
    error?.(err.message || "Error de conexión");
    // yield put(setErrors('login', err.message));
  }
}

function * fetchLogoutSaga(action) {
  try {
    const { success, error } = action.data || {}; // Destructure safely    
    let response = yield call(Api.handleDelete, routes.session.destroy, {}, {});

    if(response.status) {
      yield put(fetchLogoutOk(response));
      success?.()
    } else {
      error?.()
    }
  } catch (error) {
    if (action.data && action.data.error){ action.data.error() }
  }
}


export function * watchAuthentication() {
  yield all([
    takeLatest(FETCH_LOGIN, fetchLoginSaga),
    takeLatest(FETCH_LOGOUT, fetchLogoutSaga)
  ])
}
